import { render, staticRenderFns } from "./uploadStaff.vue?vue&type=template&id=c7064b04&"
import script from "./uploadStaff.vue?vue&type=script&lang=ts&"
export * from "./uploadStaff.vue?vue&type=script&lang=ts&"
import style0 from "./uploadStaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports